import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA, META } from '@/plugins/vuex-async-pagginate';
import { NotificationFormatter } from '@notify/services/formatter/Notification';

class NotificationServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    const param = {
      group: 'client',
      ...params
    }

    return super.getList(param).then(res => {
      console.log('dd', NotificationFormatter.formatItems(res[DATA]))
      return {
        [DATA]: NotificationFormatter.formatItems(res[DATA]),
      [META]: res[META]
      }
    }
      
    );
  }

  read(id) {
    return this.editItem(id, { is_received: true });
  }

  readAll() {
    return this.http.post(`/confirm-receipt`);
  }
}

export const NotificationService = new NotificationServiceClass({
  api_version: 2,
  resource: 'notify/notifications'
});
